<rt-confirm-dialog
  [title]="'rtu.protected_controls.dialog.title' | translate"
  [agreeLabel]="'rtu.protected_controls.dialog.agree_label' | translate"
  [cancelLabel]="'rtu.common.cancel' | translate"
  [message]="'rtu.protected_controls.dialog.message' | translate"
  [variant]="ConfirmDialogVariant.Error"
  [triggerUpdateOnInit]="true"
  [safeFooter]="true"
  [style.width.px]="400"
  [isCancelable]="true"
>
  <ul *ngIf="data.records && data.records.length > 0" margin-top-small padding-top-small>
    <li *ngFor="let controlRecord of data.records; trackBy: trackBy">
      <b>{{ controlRecord.name }}</b> {{ 'rtu.protected_controls.field_changed' | translate }}
    </li>
  </ul>
</rt-confirm-dialog>
